import { getLocaleWordContent } from '@/utils/language.util';
import React from 'react';

const ShowListCoin = ({ lst, valueCoin, total_2, setValueCoin, setShow }) => {
    const handeCheck = (coin) => {
        setValueCoin(coin);
        setShow(false);
    };

    return (
        <ul className="lst_coin">
            {lst &&
                lst
                    ?.filter((it) => it.no !== valueCoin)
                    .map((it, index) => (
                        <li key={index} onClick={() => handeCheck(it.no)} className="d_flex">
                            <div className="data_left">
                                <span>{getLocaleWordContent('알레오')}{it.no} {getLocaleWordContent('추천 갯수')}</span>
                            </div>
                            <div className="data_right">{it.total}{getLocaleWordContent('개')}</div>
                        </li>
                    ))}
            {valueCoin > 0 ? (
                <li onClick={() => handeCheck(0)} className="d_flex">
                    <div className="data_left">
                        <span>{getLocaleWordContent('추천판매수량')}:</span>
                    </div>
                    <div className="data_right">{total_2 || ''}{getLocaleWordContent('개')}</div>
                </li>
            ) : null}
        </ul>
    );
};

function SelectProduct({ lst, valueCoin, total_2, setValueCoin, setShow }) {
    return (
        <ShowListCoin lst={lst} valueCoin={valueCoin} total_2={total_2} setValueCoin={setValueCoin} setShow={setShow} />
    );
}
export default SelectProduct;
